import React from "react";
import { Copyright, ContentfulLogo, WMKLink } from "wmk-lib";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import Theme from "../../../vars/ThemeOptions";
import { graphql, useStaticQuery } from "gatsby";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
//import rtOptions from "../../../richText/richTextOptions";
import FooterColumn from "./FooterColumn";

const FooterWrap = styled(Container)`
  background-color: ${Theme.hex("concrete")};
  margin: 0;
  padding: 0;
  .main-footer {
    padding: 4vh 0;
    @media screen and (max-width: ${Theme.break.sm}px) {
      padding: 4vh 2vh;
    }
    font-size: 0.95rem;
    p {
      padding: 2vh 0;
      h6 {
        font-size: 1.125rem;
      }
    }
  }
  .bottom-footer {
    background-color: ${Theme.hex("gray")};
    margin: 0;
    padding: 0;
    .bottom-footer-inner {
      padding: 2vh 0;
      @media screen and (max-width: ${Theme.break.sm}px) {
        padding: 2vh 2vh;
      }
      font-size: 0.9rem;
    }
  }
  .wmk-link {
    color: ${Theme.hex("blue")};
    :hover {
      color: ${Theme.hex("navy")};
    }
  }
`;

const Footer = ({winWidth}) => {
  
  const isMobile = winWidth < Theme.break.sm
  const { options, contact, beliefs, links } = useStaticQuery(graphql`
    {
      options: contentfulGlobal(title: { eq: "Footer: Texas Health" }) {
        ...NodeGlobalFields
      }
      contact: contentfulGlobal(title: { eq: "Footer: Contact us" }) {
        ...NodeGlobalFields
      }
      beliefs: contentfulGlobal(title: { eq: "Footer: Our Beliefs" }) {
        ...NodeGlobalFields
      }
      links: contentfulGlobal(title: { eq: "Footer: Links" }) {
        ...NodeGlobalFields
      }
    }
  `);
  return (
    <FooterWrap fluid>
      <footer>
        <Container className="main-footer">
          <Row>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Row className="flex-column">
                <Col xs={8} sm={8} md={12}>
                  <ContentfulLogo
                    url={options.logo.file.url}
                    contentType={options.logo.file.contentType}
                    alt={options.name}
                  />
                </Col>
                <Col>
                  {documentToReactComponents(options.text.json)}
                </Col>
              </Row>
            </Col>
            <Col xs={6} sm={6} md={4} lg={4}>
              <FooterColumn column={contact} isMobile={isMobile}/>
            </Col>
            <Col xs={6} sm={6} md={4} lg={4}>
              <FooterColumn column={beliefs} isMobile={isMobile} />
            </Col>
          </Row>
        </Container>
      </footer>
      <Container fluid className="bottom-footer">
        <Container className="bottom-footer-inner">
          <Row>
            <Col xs="auto">
              <Copyright>
                {options.name} Resources. All Rights Reserved
              </Copyright>
            </Col>
            {links.links &&
              links.links.length &&
              links.links.map((link, i) => {
                return (
                  <Col key={"linkfooter" + i} xs={12} md="auto">
                    <WMKLink to={link.url} target={link.target}>
                      {link.title}
                    </WMKLink>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </Container>
    </FooterWrap>
  );
};

export default Footer;
